import { makeNewButton } from "/buttons_functions/custom_button_functions.js";
import { createBranchPreview, drawLine, getParentBottomCenter, getChildTopCenter, createTreeConnectionsForAll } from "/explore_field_functions/content_preview.js";
import { API_GATEWAY } from "/constants/API_constants.js"
import { createElement } from "/elements_functions/new_elements.js";
import { createIdsForRevealFromVirgins } from '/explore_field_functions/ids_functions.js';
import { insertPlaqueAndAlertWindow } from "/alert/alert_functions.js";

const sideDictionary = {
    'left' : 'explore-window-branch-reveal-children-left',
    'right' : 'explore-window-branch-reveal-children-right'
}

export function createRevealChildrenBottom(parentWrapper, ids, buildFunctionsDictionary=null) {
    const revealButton = createElement('div', null, ['explore-window-branch-reveal-children', 'explore-window-branch-reveal-children-bottom']);
    const revealButtonCaption = createElement('p', null, null);
    revealButtonCaption.innerText = `+${ids.toReveal.length + ids.toRevealLater.length} children`;

    revealButton.append(revealButtonCaption);

    makeNewButton(revealButton, 'rgb(58, 58, 58)', 'white', null, 'lighten', null);

    revealButton.addEventListener('click', ()=>revealMoreChildren(parentWrapper, ids, buildFunctionsDictionary));

    return revealButton;
}

export function createRevealMoreChildrenSide(parentWrapper, ids, side, buildFunctionsDictionary=null) {
    const revealButton = createElement('div', null, [sideDictionary[side], 'explore-window-branch-reveal-children-side', 'explore-window-branch-reveal-children']);
    const revealButtonCaption = createElement('p', null, null);
    revealButtonCaption.innerText = `+${ids.toReveal.length + ids.toRevealLater.length} children`;

    revealButton.append(revealButtonCaption);

    makeNewButton(revealButton, 'rgb(58, 58, 58)', 'white', null, 'lighten', null);

    revealButton.addEventListener('click', ()=>revealMoreChildren(parentWrapper, ids, buildFunctionsDictionary));

    return revealButton;

}



async function revealMoreChildren(parentWrapper, ids, buildFunctionsDictionary=null) {

    console.log("revealing ids", ids);
    
    const dataBranches = await getNodesByIds(ids.toReveal);
    const parent = parentWrapper.querySelector('.explore-window-branch');
    const lineage = parentWrapper.querySelector('.explore-window-branch-wrapper-lineage');

    if(buildFunctionsDictionary!==null && buildFunctionsDictionary.beforeRevealMore!==null && buildFunctionsDictionary.beforeRevealMore instanceof Function) {
        const beforeRevealMoreFunction = () =>
            buildFunctionsDictionary.beforeRevealMore(lineage.parentId)
        beforeRevealMoreFunction();
    }

    const newBranchesDictionary = {};

    const newBranches = [];

    for(let newBranch of dataBranches) {
        const newBranchWrapper = createBranchPreview(newBranch, null, buildFunctionsDictionary);
        const newBranchElement = newBranchWrapper.exploreBranchesDictionary[newBranch.id];
        newBranches.push(newBranchWrapper);
        newBranchesDictionary[newBranch.id] = newBranchElement;
    }
    
    for(let i of lineage.children) {
        if(i.classList.contains('explore-window-branch-reveal-children'))
            i.remove();
    }

    if(!(ids.toRevealLater===null || ids.toRevealLater.length===0)) {
        ids = createIdsForRevealFromVirgins(ids.toRevealLater, 3);
        //lineage.insertAdjacentElement('afterbegin', createRevealMoreChildrenSide(parentWrapper, ids, 'left'));
        newBranches.push(createRevealMoreChildrenSide(parentWrapper, ids, 'right', buildFunctionsDictionary));
    }
    
    lineage.append(...newBranches);

    console.log("dataBranches ", dataBranches);
    

    if(buildFunctionsDictionary!==null && buildFunctionsDictionary.onRevealMore!==null && buildFunctionsDictionary.onRevealMore instanceof Function) {
        const onRevealMoreFunction = (dataBranches, newBranchesDictionary) =>
            buildFunctionsDictionary.onRevealMore(lineage.parentId, dataBranches, newBranchesDictionary)
        onRevealMoreFunction(dataBranches, newBranchesDictionary);
    }
}

async function getNodesByIds(...ids) {
    const url = new URL(API_GATEWAY+'branches/get/list/by-ids'); // Base URL
    ids.forEach(id => url.searchParams.append("list", id));

    const response = await fetch(url, {
        method: 'GET'
    });

    if(response.status===200) {
        return response.json();
    } else {
        insertPlaqueAndAlertWindow("Something went wrong while loading up more children!");
        return null;
    }

}

function redrawTheFamilyTree(parent, lineage, wrapper) {
    wrapper.querySelector('.explore-window-branch-wrapper-lineage-link').remove();
    const children = lineage.children;

    // Create and configure canvas
    const canvas = document.createElement("canvas");
    canvas.classList.add("explore-window-branch-wrapper-lineage-link");
    canvas.width = wrapper.clientWidth;
    canvas.height = 50;

    const ctx = canvas.getContext("2d");

    const parentCenter = getParentBottomCenter(parent, wrapper);

    for(let child of children) {
        const childCenter = getChildTopCenter(child, wrapper);

        // Midpoint for the zig-zag connection
        const midY = parentCenter.y + (childCenter.y - parentCenter.y) / 2;

        drawLine(ctx, parentCenter.x, 0, parentCenter.x, canvas.height/2, childCenter.x, canvas.height);
    }

    parent.insertAdjacentElement('afterend', canvas);

}

function findExploreFieldThroughParents(element) {
    while(!element.classList.contains('explore-mini-field')) {
        element = element.parentElement;
    }

    return element;
}